import { useLang } from '../i18n';
import { STATEMENT } from '../legal/accessibility';
import { LegalBar } from './terms';

/** Public page: the accessibility statement required by IS 5568 regulations. Hebrew is the original. */
export function Accessibility() {
  const { lang } = useLang();
  const doc = STATEMENT[lang];
  return (
    <div className="terms">
      <LegalBar />
      <main className="terms-body">
        <h1>{doc.title}</h1>
        <p className="muted small">{doc.updated}</p>
        {doc.intro.map((p, i) => <p key={i}>{p}</p>)}
        {doc.sections.map((s, i) => (
          <section key={i}>
            <h2>{s.title}</h2>
            {s.paras?.map((p, j) => <p key={j}>{p}</p>)}
            {s.list && <ul className="statement-list">{s.list.map((l, k) => <li key={k}>{l}</li>)}</ul>}
          </section>
        ))}
      </main>
    </div>
  );
}
